module.exports = __webpack_public_path__ + "static/media/Draco Malfoy 3.84403747.jpg";